import React from 'react';

import { useFeatures } from '@atc/features';

import {
    Footer,
} from '@kbbsdk/global-sdk/navigation/web';

import { sendClick } from 'reaxl-analytics';

import navigation from '@/config/kbbGlobalNavV2.json';

import ArgoThemeProvider from '@/containers/ArgoThemeProvider';

function FooterContainer(props) {
    const {
        col_enable_one_trust_footer: [enableOneTrustFooter],
    } = useFeatures([
        'col_enable_one_trust_footer',
    ]);

    const handleFooterClick = (eventResult) => {
        if (eventResult === 'text-link::manage-cookies') {
            sendClick('footerLinkClick', {}, { text: 'manage-cookies' });
        }
    };

    return (
        <Footer
            enableGtm
            navigation={navigation}
            enableOneTrust={enableOneTrustFooter}
            handleFooterClick={handleFooterClick}
            {...props}
        />
    );
}

function KBBFooter(props) {
    return (
        <ArgoThemeProvider brand="kbb">
            <FooterContainer {...props} />
        </ArgoThemeProvider>
    );
}

export default KBBFooter;
